<div class="flex flex-col p-3 bg-white min-h-full min-w-full rounded">
  <div class="grid grid-cols-1 justify-between items-center">
    <div class="flex font-app-bold">
      <div class="flex items-center justify-between w-full">
        <span class="font-app-regular text-darkest text-sm col-start-1">{{ "quotation.until" | translate }}</span>
      </div>
      <span class="text-sm font-app-regular text-dark">{{ quotationMember.validityDate | date: "dd/MM/yyyy" }}</span>
    </div>
    <div class="flex justify-between items-center pt-1 mt-3">
      <span class="font-app-regular text-darkest text-sm">{{ "quotation.amount" | translate }}</span>
      <span class="text-darkest font-app-bold text-sm">{{
        quotationMember.monthlyPremiumTTC | currency: "EUR" : "symbol" : "" : "fr"
      }}</span>
    </div>
    <div
      class="flex justify-between items-center pt-1 mt-3"
      *ngIf="quotationMember.promotionCode !== null">
      <span class="font-app-regular text-darkest text-sm">{{ "quotation.promotionCode" | translate }}</span>
      <span class="text-dark font-app-regular text-sm">{{ quotationMember.promotionCode }}</span>
    </div>
  </div>
</div>

